import { isFailed, isShowLoader, selectError, useAppSelector } from '@libs/store';
import { ConditionalRender } from '@libs/utils';
import React, { useEffect } from 'react';
import { SpinnerCircle } from './common/SpinnerCircle';
import { CommonScreen } from './CommonScreen/CommonScreen';
import { zIndex } from './utils/constants';
import { CrossRoundedIcon } from './utils/CrossRounded';
import { Div } from './utils/styled';

export const WidgetWrapper = ({ children }: { children: React.ReactNode }) => {
    const isLoader = useAppSelector(isShowLoader);
    const isStatusFlailed = useAppSelector(isFailed);
    const errors = useAppSelector(selectError);

    useEffect(() => {
        if (isLoader) {
            // @ts-expect-error
            document?.activeElement?.blur?.();
        }
    }, [isLoader]);

    return (
        <>
            <ConditionalRender condition={isStatusFlailed}>
                <CommonScreen color="#F1557F" Icon={CrossRoundedIcon} mainText={errors?.errorMessage} />
            </ConditionalRender>
            <ConditionalRender condition={isLoader}>
                <Div sx={{ opacity: 0.4, zIndex: zIndex.loaderLayout, position: 'relative' }}>
                    <CommonScreen Icon={SpinnerCircle} />
                </Div>
            </ConditionalRender>
            <ConditionalRender condition={!isStatusFlailed}>{children}</ConditionalRender>
        </>
    );
};
